import React, { useLayoutEffect, useRef, useState } from "react";

// Skaliert eine feste A4-Breite (794px = 210mm) auf die verfügbare Containerbreite (Handy/iPad). Desktop = 1:1.
export default function FitA4({ children, baseWidth = 794, className = "" }) {
  const wrapRef = useRef(null);
  const innerRef = useRef(null);
  const [fit, setFit] = useState({ scale: 1, height: null });

  useLayoutEffect(() => {
    const wrap = wrapRef.current;
    const inner = innerRef.current;
    if (!wrap || !inner) return;
    const update = () => {
      const w = wrap.clientWidth;
      const s = w > 0 ? Math.min(1, w / baseWidth) : 1;
      setFit(prev => {
        const h = s < 1 ? Math.ceil(inner.offsetHeight * s) : null;
        return prev.scale === s && prev.height === h ? prev : { scale: s, height: h };
      });
    };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(wrap);
    ro.observe(inner);
    return () => ro.disconnect();
  }, [baseWidth]);

  const scaled = fit.scale < 1;
  return (
    <div
      ref={wrapRef}
      className={`w-full ${className}`}
      style={scaled ? { height: fit.height ?? undefined, overflow: "hidden" } : undefined}
      data-testid="fit-a4"
    >
      <div
        ref={innerRef}
        style={scaled ? { width: baseWidth, transform: `scale(${fit.scale})`, transformOrigin: "top left" } : undefined}
      >
        {children}
      </div>
    </div>
  );
}
